// External Imports
import { createGlobalStyle, css } from '@lessonnine/design-system.lib';

// Local Variables
const playButtonSize = 70;
const playButtonTriangleSize = playButtonSize / 5;
const youtubeGlobalClassNamePrefix = 'babbel-youtube-lazy-load';

const wrapperStyle = css`
  align-items: center;
  display: flex;
  justify-content: center;
`;

/*
:global([class^="embed"]) .lazyLoadEmbed {
  @include intrinsicContent;
}
*/

const thumbnailStyle = css`
  cursor: pointer;
  height: 100%;
  max-width: 100%;
  transition: filter 0.2s ease-in-out;
  width: auto;
`;

const playButtonStyle = css`
  background-color: rgb(30 30 30 / 80%);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  height: ${playButtonSize}px;
  left: 50%;
  padding: 0;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  /* stylelint-disable-next-line plugin/no-low-performance-animation-properties -- no alternative for color transformations */
  transition: background-color 0.2s ease-in-out;
  width: ${playButtonSize}px;

  &::before {
    border-bottom: ${playButtonTriangleSize}px solid transparent;
    border-left: ${playButtonTriangleSize}px solid white;
    border-top: ${playButtonTriangleSize}px solid transparent;
    content: ' ';
    height: 0;
    overflow: visible;
    position: absolute;
    right: 50%;
    top: calc(50% - ${playButtonTriangleSize}px);
    transform: scaleX(1.3) translateX(50%);
    width: 0;
  }
`;

const visuallyHiddenStyle = css`
  clip: rect(0 0 0 0);
  /* stylelint-disable-next-line plugin/no-unsupported-browser-features -- false positive, basic shape is supported by all browsers */
  clip-path: inset(100%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const hoverOverlayStyle = css`
  display: flex;
  height: 100%;
  justify-content: center;
  position: relative;
  width: 100%;

  &:hover {
    /* Those are not the greatest as they target the elements directly, but couldn't find a way to do better
       TODO: in the future, we could move those to the img and button style and use :has to select when parent is hovered, but for now it's not supported in Firefox */
    img {
      filter: brightness(0.5);
    }

    button {
      background-color: rgb(255 0 0);
    }
  }
`;

// Local Functions

const makeClassName = (element) => [youtubeGlobalClassNamePrefix, element].join('__');

const stylesMap = {
  hoverOverlay: hoverOverlayStyle,
  playButton: playButtonStyle,
  thumbnail: thumbnailStyle,
  visuallyHidden: visuallyHiddenStyle,
  wrapper: wrapperStyle,
};

const classNamesMap = {};
for (const elementName of Object.keys(stylesMap)) {
  classNamesMap[elementName] = makeClassName(elementName);
}

const GlobalYoutubeLazyLoadStyle = createGlobalStyle`
  ${Object.keys(stylesMap).map(
    (elementName) => css`
      .${classNamesMap[elementName]} {
        ${stylesMap[elementName]}
      }
    `,
  )}
`;

// Module Exports
export { stylesMap, GlobalYoutubeLazyLoadStyle, classNamesMap };
